// removed by extract-text-webpack-plugin
module.exports = {"app":"_2hfFHIuy42dRnVenySvIvd","app-logo":"_2HPt66SXnxUR7Qgy7j-UIb","app-logo-spin":"_2aeBuSp5FiavPqc9wqsZNd","header":"_1OUvt2f-4HKWvym0EpthS0","lists":"_7LC0-n6OoWdtc-8H8nrCX","title":"_1VxzAJS-eYRX48kYVokDZB","app-intro":"fPzkXaVrIqp_50KFACtYX"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 28
// module chunks = 0